import template from './template.html';
import './styles.css';

controller.$inject = ['$scope'];

export function controller($scope) {
    let vm = {};
    this.$onInit = function() {
    vm = this;
    vm.select = select;
    vm.clear = clear;

    const duration = getHoursDiff(vm.data.start, vm.data.end);
    const driverName = formatDriverName(vm.data.driverName);

    vm.shift = {
        duration,
        start: vm.data.start,
        end: vm.data.end,
        driverName,
        violations: (vm.data.violations || []).join('\n'),
        warnings: (vm.data.warnings || []).join('\n'),
    };
}

    function select() {
        $scope.$emit('shift-selected', vm.data, vm.driverHoliday);
    }

    function clear() {
         $scope.$emit('shift-cleared', vm.data); 
    }

    function getHoursDiff(a, b) {
        const start = new Date(a);
        const end = new Date(b);
        const diff = end - start;

        return (diff / 1000 / 60 / 60).toFixed(2);
    }
    
    function formatDriverName(name) {
        const maxLength = 15;
        var driverName = '';
        if ((name != null) && (name.length > maxLength)) {
            driverName = name.substr(0, (maxLength -3)) + '...';
        } else {
            driverName = name;
        }
        return driverName;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        data: '=',
        driverHoliday: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/shift/index.js